import { Button } from "@/components/ui/button";

type FormSubmitButtonProps = {
  isEdit?: boolean;
  addText?: string;
  editText?: string;
  loadingText?: string;
  addLoadingText?: string;
  editLoadingText?: string;
  isPending?: boolean;
} & React.ComponentProps<typeof Button>;

const FormSubmitButton = ({
  isEdit = false,
  addText = "Create",
  editText = "Update",
  loadingText,
  addLoadingText = "Creating...",
  editLoadingText = "Updating...",
  isPending = false,
  ...buttonProps
}: FormSubmitButtonProps) => {
  return (
    <Button type="submit" disabled={isPending} {...buttonProps}>
      {isPending
        ? loadingText ?? (isEdit ? editLoadingText : addLoadingText)
        : isEdit
        ? editText
        : addText}
    </Button>
  );
};

export default FormSubmitButton;
